/** The six hues of the design system. Colour in Hestia means exactly two things:
 *  who owns a task, and which list it is in. Nothing else may carry a hue. */
export const HUES = ['lilac', 'sky', 'mint', 'pink', 'amber', 'coral'];
/** Deterministic so a tag keeps the same colour wherever it is created — the web
 *  app, the CLI and the bot all land on the same hue for the same word. `coral`
 *  is excluded: it is reserved for destructive actions and appears nowhere else. */
const TAG_HUES = ['lilac', 'sky', 'mint', 'pink', 'amber'];
export function hueForTag(slug) {
    let h = 0;
    for (let i = 0; i < slug.length; i++)
        h = (h * 31 + slug.charCodeAt(i)) >>> 0;
    return TAG_HUES[h % TAG_HUES.length];
}
export function slugifyTag(input) {
    return input.trim().toLowerCase().replace(/^#+/, '').replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '').slice(0, 40);
}
//# sourceMappingURL=types.js.map